import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AngularFirestore } from '@angular/fire/firestore';
import { Delivery, Iaddress, Users } from 'my-lib-sanfelici/my-lib-sanfelici';
import { UsersService } from 'my-lib-sanfelici';
import { DeliveryService } from 'my-lib-sanfelici';
import { NewMapsDialogViewComponent } from '../../new-maps/new-maps-dialog-view/new-maps-dialog-view.component';


@Component({
  selector: 'app-delivery-edit',
  templateUrl: './delivery-edit.component.html',
  styleUrls: ['./delivery-edit.component.css']
})
export class DeliveryEditComponent implements OnInit {
delivery: Delivery;
id: string;
address: Iaddress;
user: Users;
  constructor(
    public dialog: MatDialog,
    private usersservice: UsersService,
    private db: AngularFirestore,
    private deliveryservice: DeliveryService,
    private router: Router,
    private route: ActivatedRoute) { }
    openDialog(): void {
      const dialogRef = this.dialog.open(NewMapsDialogViewComponent, {

      });

      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
        console.log(result);
        this.address = result;
        console.log(this.address);
        this.delivery.address=this.address;

      });
    }
    onSubmit() {

      this.user.delivery = this.delivery;
      this.usersservice.update(this.user).then(() => {
        this.router.navigate(['/myuser',  'delivery', 'details', this.id]);

       });
         }
  ngOnInit() {
    this.id = this.route.snapshot.params.id;
    this.deliveryservice.get(this.id).subscribe(d => this.delivery = d);
    this.usersservice.details(this.id).subscribe(u => this.user = u);
  }

}
